const carouselLocale = {
  previousSlide: "Previous Slide",
  nextSlide: "Next Slide"
};
export {
  carouselLocale
};
//# sourceMappingURL=en_US.js.map
